import { registeredTabsHandlers } from '@/global/components/view-layouts/tabs-layout/common/registered-tabs-handlers'
import profileSettingsTooltip from '../../components/ProfileSettingsTooltip.vue'
import { createNamespacedHelpers } from 'vuex'
const { mapActions } = createNamespacedHelpers('base/config')

const TAB_KEY = 'settings'
export default {
  name: 'settingsTabs',

  data () {
    return {
      indexModalConfig: {
        dialog: false,
        dialogTitle: '',
        cancelText: '',
        actionText: '',
        actionConfirmed: null,
        closeDialog: null
      },
      selectedHomePage: null,
      treeViewItems: {
        items: [],
        open: []
      },
      treeViewTranslations: {},
      updateData: null,
      tempSelectedHomePage: null
    }
  },

  computed: {
    settingsTabConfig () {
      return {
        title: this.$t('base/profile.settings'),
        key: TAB_KEY,
        apiConfig: {
          get: {
            module: 'base',
            route: 'profile/get-settings',
            method: 'get'
          },
          post: {
            module: 'base',
            route: 'profile/update-settings',
            method: 'post',
            usePatch: false
          }
        },
        onDataReceived: (data) => this.onDataReceived(data),
        afterSave: (event, data) => this.onSettingsAfterSave(event, data),
        tabContent: [
          {
            title: this.$t('base/profile.settings'),
            component: this.columnsContentComponent,
            showButtons: true,
            cardStyle: {
              maxWidth: '880px'
            },
            rows: [
              {
                type: 'fields',
                columnsCount: 2,
                fields: [
                  {
                    key: 'home_page',
                    label: this.$t('base/profile.selected_home_page_label'),
                    placeholder: this.$t('base/profile.selected_home_page_placeholder'),
                    tooltip: {
                      component: profileSettingsTooltip,
                      color: 'transparent',
                      direction: 'right',
                      config: {
                        text: this.$t('base/profile.home_page_info')
                      }
                    },
                    appendIcon: 'mdi-menu-down',
                    onClick: (event) => this.onChooseStartPage(event),
                    options: {
                      custom_display_value: (val) => {
                        return val && this.treeViewTranslations[val] ? this.treeViewTranslations[val] : ''
                      }
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'remember_vehicle_selection',
                    type: 'autocomplete',
                    label: this.$t('base/profile.remember_vehicle_selection_label'),
                    placeholder: this.$t('base/profile.remember_vehicle_selection_placeholder'),
                    tooltip: {
                      component: profileSettingsTooltip,
                      color: 'transparent',
                      direction: 'right',
                      config: {
                        text: this.$t('base/profile.remember_vehicles_info')
                      }
                    },
                    items: [
                      {
                        id: 1,
                        name: 'Da'
                      },
                      {
                        id: 0,
                        name: 'Ne'
                      }
                    ],
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'default_zoom_on_vehicles',
                    type: 'autocomplete',
                    label: this.$t('base/profile.default_zoom_on_vehicles_label'),
                    placeholder: this.$t('base/profile.default_zoom_on_vehicles_placeholder'),
                    tooltip: {
                      component: profileSettingsTooltip,
                      color: 'transparent',
                      direction: 'right',
                      config: {
                        text: this.$t('base/profile.default_zoom_on_vehicle_tooltip_text')
                      }
                    },
                    items: [
                      {
                        id: 0,
                        name: '20%'
                      },
                      {
                        id: 1,
                        name: '40%'
                      },
                      {
                        id: 2,
                        name: '60%'
                      },
                      {
                        id: 3,
                        name: '80%'
                      }
                    ],
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'application_color_theme',
                    type: 'autocomplete',
                    label: this.$t('base/profile.application_color_theme_label'),
                    placeholder: this.$t('base/profile.application_color_theme_placeholder'),
                    tooltip: {
                      component: profileSettingsTooltip,
                      color: 'transparent',
                      direction: 'right',
                      config: {
                        text: this.$t('base/profile.application_color_theme_tooltip_text')
                      }
                    },
                    items: [
                      {
                        id: 0,
                        name: this.$t('base.dark_theme')
                      },
                      {
                        id: 1,
                        name: this.$t('base.light_theme')
                      }
                    ],
                    creatable: true,
                    editable: true,
                    visible: true
                  }
                ]
              }
            ]
          },
          {
            title: this.$t('base/profile.change_password'),
            component: this.columnsContentComponent,
            cardStyle: {
              maxWidth: '880px'
            },
            rows: [
              {
                type: 'fields',
                columnsCount: 1,
                fields: [
                  {
                    key: 'current_password',
                    label: this.$t('base/profile.current_password'),
                    field_type: 'password',
                    placeholder: this.$t('base/profile.current_password_placeholder'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'password',
                    label: this.$t('base/profile.new_password'),
                    tooltip: {
                      component: profileSettingsTooltip,
                      color: 'transparent',
                      direction: 'right',
                      config: {
                        text: this.$t('base/profile.new_password_between_error')
                      }
                    },
                    field_type: 'password',
                    placeholder: this.$t('base/profile.new_password_placeholder'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'password_confirmation',
                    label: this.$t('base/profile.confirm_new_password'),
                    field_type: 'password',
                    placeholder: this.$t('base/profile.confirm_new_password_placeholder'),
                    creatable: true,
                    editable: true,
                    visible: true
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  },

  methods: {
    ...mapActions(['fetch']),

    onChooseStartPage (event) {
      const { editMode } = event || {}
      if (!editMode) {
        return
      }

      this.openSelectedTreeViewItems()
      this.$set(this.indexModalConfig, 'dialog', true)
      this.$set(this.indexModalConfig, 'dialogTitle', this.$t('base/profile.select_home_page'))
      this.$set(this.indexModalConfig, 'actionText', this.$t('base.save'))
      this.$set(this.indexModalConfig, 'cancelText', this.$t('base.cancel'))
      this.$set(this.indexModalConfig, 'actionConfirmed', async () => await this.onConfirmStartPageCallback())
      this.$set(this.indexModalConfig, 'closeDialog', () => this.onCloseDialogCallback())
    },

    // When user confirms default start page, update form data with new selected home_page parameter
    async onConfirmStartPageCallback () {
      const { updateData } = registeredTabsHandlers[TAB_KEY] || {}

      updateData?.({
        home_page: [this.selectedHomePage[this.selectedHomePage.length - 1]]
      })
      this.tempSelectedHomePage = [...[this.selectedHomePage[this.selectedHomePage.length - 1]]]
      this.$set(this.indexModalConfig, 'dialog', false)
    },

    // User closed changing start page dialog
    onCloseDialogCallback () {
      this.$set(this.indexModalConfig, 'dialog', false)
      this.selectedHomePage = this.tempSelectedHomePage
    },

    onDataReceived (data) {
      const formData = data?.data ?? {}
      const {
        home_page_items: homePageItems,
        home_page: homePage,
        home_page_items_translations: treeViewTranslations
      } = formData || null

      this.treeViewTranslations = treeViewTranslations

      if (homePageItems) {
        this.treeViewItems = {
          items: homePageItems,
          open: []
        }
      }

      if (homePage) {
        this.selectedHomePage = homePage
        this.tempSelectedHomePage = [...homePage]
      }

      this.openSelectedTreeViewItems()
    },

    onSettingsAfterSave (event, data) {
      const { home_page: homePage } = data || {}
      if (homePage) {
        // re-fetch config so clicking on company logo in app-bar can redirect user to the home page if it changed
        this.fetch().then()
      }
    },

    openSelectedTreeViewItems () {
      if (this.treeViewItems.items.length && this.selectedHomePage[0]) {
        this.treeViewItems.open = []
        const queue = this.treeViewItems.items.map(item => {
          return { node: item, parentKey: null }
        })

        while (queue.length) {
          const currentNode = queue[0]

          if (currentNode.node.id === this.selectedHomePage[0]) {
            if ('children' in currentNode.node) {
              this.treeViewItems.open.push(currentNode.node.id)
              break
            }
            else {
              const parentNode = this.treeViewItems.items.find(item => item.id === currentNode.parentKey)
              if (parentNode) {
                this.treeViewItems.open.push(currentNode.parentKey)
                break
              }
            }
          }

          if (currentNode.node.children?.length) {
            const children = currentNode.node.children.map(item => ({
              node: item,
              parentKey: currentNode.node.id
            }))
            queue.push(...children)
          }

          queue.shift()
        }
      }
    }
  }
}
